import { render, staticRenderFns } from "./myTree.vue?vue&type=template&id=52ddf37c&"
import script from "./myTree.vue?vue&type=script&lang=js&"
export * from "./myTree.vue?vue&type=script&lang=js&"
import style0 from "./myTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports